/**
 * Find the closest match for num in array
 * @param {number} num The number we want to select
 * @param {array} array The array of allowed numbers
 */
export default function(num, array) {
    if (array.length == 0) {
        return num;
    }
    let curr = array[0];
    let diff = Math.abs (num - curr);
    for (let val = 0; val < array.length; val++) {
        let newdiff = Math.abs (num - array[val]);
        if (newdiff < diff) {
            diff = newdiff;
            curr = array[val];
        }
    }
    return curr;
}


// WEBPACK FOOTER //
// ./resources/assets/js/modules/arrayClosestMatch.js